import store from '@/store';
import { BroadcastChannel } from 'broadcast-channel';

type Message = {
  action: string;
};

let broadcastChannel: BroadcastChannel<Message> = null;

const initChannel = () => {
  broadcastChannel = new BroadcastChannel('application-state');
  broadcastChannel.onmessage = (ev) => {
    if (ev.action === 'logout') {
      store.dispatch('user/logout', true);
    }
  };
};

const closeChannel = () => {
  broadcastChannel.close();
  broadcastChannel = null;
};

const broadcastLogout = () => {
  broadcastChannel.postMessage({ action: 'logout' });
};

export { broadcastLogout, closeChannel, initChannel };
